/*
  ============================================================
  summer-quick-view.js — olhada rapida em modal
  ============================================================

  O QUE FAZ:
  Intercepta o botao de olhada rapida do card, busca
  `/products/<handle>?view=summer-quick` e abre o resultado num modal.
  Fecha no ESC, no veu, no X e depois que o produto entra no carrinho.

  A resposta e pequena porque templates/product.summer-quick.liquid usa
  `layout none`: vem so a secao, sem cabecalho, rodape nem folha de
  estilo. Nao ha recorte de pagina inteira acontecendo aqui.

  O QUE NAO FAZ:
  nao monta o conteudo. Quem desenha a olhada rapida e
  sections/summer-quick-view.liquid, e o que chega aqui e HTML pronto —
  se algum dia for preciso montar preco ou variante no cliente, e sinal
  de que o pedaco errado foi para o JavaScript.

  SEM ESTE ARQUIVO A LOJA FUNCIONA:
  o botao e um <a href> apontando para a PDP. Bloqueado, com erro ou fora
  do ar, o clique navega para a pagina do produto — que e exatamente o
  que o botao "Escolher opcoes" fazia antes de existir olhada rapida.
  Por isso o botao NAO e <button>: um <button> sem JS nao leva a lugar
  nenhum.

  O MODAL E UNICO:
  criado sob demanda e reaproveitado. Um modal por card seria um modal
  por produto na pagina, todos vazios, so esperando.

  SUMMER: DOIS CONSUMIDORES, UM MODAL SO.
  O painel de produtos do guia (snippets/summer-guia-atalho.liquid) precisa
  exatamente do que este arquivo ja faz: buscar uma url com `?view=`, por o
  HTML num dialogo, prender o foco, fechar no ESC, no veu e quando o produto
  entra no carrinho. Escrever um segundo modal para isso seria duplicar veu,
  armadilha de foco e animacao de entrada — e manter duas versoes delas.

  O que era especifico da olhada rapida virou contrato de atributo no
  gatilho, com os valores dela como padrao:

    data-summer-quick-view-open ... gatilho da olhada rapida (como antes)
    data-summer-panel-open ........ gatilho generico
    data-summer-panel-view ........ nome do `?view=` a buscar
    data-summer-panel-content ..... seletor do que extrair da resposta

  Nenhum chamador existente precisou mudar: sem os atributos novos, o
  comportamento e o de sempre.

  SUMMER: O ARQUIVO PODE SER INCLUIDO MAIS DE UMA VEZ.
  layout/theme.liquid so o emite com a setting de olhada rapida ligada, mas o
  indice de guias precisa dele independentemente dessa setting — e o inclui
  por conta propria. Com as duas fontes ativas, o navegador executaria o
  arquivo duas vezes, registrando os ouvintes de documento em dobro: cada
  clique abriria e buscaria duas vezes. A trava abaixo faz a segunda execucao
  sair sem fazer nada.
*/
(function () {
  'use strict';

  if (window.__summerPainelPronto) return;
  window.__summerPainelPronto = true;

  var GATILHO = '[data-summer-quick-view-open], [data-summer-panel-open]';
  var VIEW_PADRAO = 'summer-quick';
  var CONTEUDO_PADRAO = '[data-summer-quick-view]';
  var ID_MODAL = 'SummerQuickView';
  var ID_TITULO = 'SummerQuickViewTitle';

  var FOCAVEIS =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var modal = null;
  var painel = null;
  var corpo = null;
  var gatilhoAtivo = null;
  var emVoo = null;
  var revelado = false;

  function construir() {
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'summer-qv-modal';
    modal.id = ID_MODAL;
    modal.hidden = true;
    /* SUMMER: o painel nasce com nome acessivel. Um role="dialog" sem nome e
       anunciado so como "dialogo", sem dizer de que produto se trata — e os
       outros dois dialogos do tema (carrinho lateral e menu mobile) ja
       trazem aria-label. Este e o rotulo generico; assim que o conteudo
       chega, nomear() troca por aria-labelledby apontando para o titulo do
       produto, que e o nome de verdade. */
    var rotulo = (window.themeStrings && window.themeStrings.quickView) || 'Olhada rápida';

    modal.innerHTML =
      '<div class="summer-qv-modal__scrim" data-summer-qv-close></div>' +
      '<div class="summer-qv-modal__panel" role="dialog" aria-modal="true" tabindex="-1" aria-label="' +
      rotulo.replace(/"/g, '&quot;') +
      '">' +
      '<button type="button" class="summer-qv-modal__close" data-summer-qv-close aria-label="' +
      (window.themeStrings && window.themeStrings.close ? window.themeStrings.close : 'Fechar') +
      '"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<div class="summer-qv-modal__body" data-summer-qv-body></div>' +
      '</div>';

    document.body.appendChild(modal);
    painel = modal.querySelector('.summer-qv-modal__panel');
    corpo = modal.querySelector('[data-summer-qv-body]');

    modal.addEventListener('click', function (evento) {
      if (evento.target.closest('[data-summer-qv-close]')) fechar();
    });

    return modal;
  }

  function abrir(gatilho) {
    gatilhoAtivo = gatilho;
    construir();

    corpo.innerHTML = '';
    modal.classList.add('is-loading');
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';

    /* Um quadro de espera antes de revelar: a classe precisa entrar num tick
       DEPOIS do `hidden = false`, senao o navegador aplica display e opacidade
       no mesmo quadro e a transicao de entrada nao acontece.

       SUMMER: o setTimeout ao lado nao e redundancia — e a rede de seguranca.
       `requestAnimationFrame` nao dispara enquanto o documento esta oculto
       (aba em segundo plano, janela minimizada, economia de bateria). Sem ele
       o modal ficava no pior estado possivel: `hidden` ja era false e o
       `overflow: hidden` do documento ja estava posto, mas `is-open` nunca
       entrava — painel translucido, veu invisivel, pagina atras travada e sem
       jeito de fechar a nao ser pelo ESC. Foi exatamente o que aconteceu ao
       testar em aba oculta.

       `revelar` e idempotente, entao em aba visivel o rAF chega primeiro
       (~16ms) e o timeout vira um no-op. A ordem nao importa; a garantia sim. */
    revelado = false;
    window.requestAnimationFrame(revelar);
    window.setTimeout(revelar, 80);

    buscar(gatilho);
  }

  /* Foco logo apos a classe, e nao num segundo quadro: `opacity` nao tira o
     elemento da arvore de foco, ao contrario de `visibility`. */
  function revelar() {
    if (revelado || !modal) return;
    revelado = true;
    modal.classList.add('is-open');
    painel.focus({ preventScroll: true });
  }

  function buscar(gatilho) {
    if (emVoo) emVoo.abort();
    var controle = new AbortController();
    emVoo = controle;

    var url = gatilho.getAttribute('href');
    var view = gatilho.getAttribute('data-summer-panel-view') || VIEW_PADRAO;
    var seletor = gatilho.getAttribute('data-summer-panel-content') || CONTEUDO_PADRAO;

    var separador = url.indexOf('?') > -1 ? '&' : '?';
    var alvo = url + separador + 'view=' + encodeURIComponent(view);

    fetch(alvo, { signal: controle.signal })
      .then(function (r) {
        if (!r.ok) throw new Error('status ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        /* O painel do guia marca a propria raiz; a olhada rapida usa o
           seletor padrao. Um `||` cobre os dois sem o chamador precisar
           declarar nada quando o padrao serve. */
        var conteudo = doc.querySelector(seletor) || doc.querySelector('[data-summer-panel-root]');
        if (!conteudo) throw new Error('conteudo do painel nao encontrado na resposta');

        corpo.appendChild(conteudo);
        modal.classList.remove('is-loading');
        nomear(conteudo);
      })
      .catch(function (erro) {
        if (erro.name === 'AbortError') return;
        /* Nao ha o que remendar dentro do modal: o destino que o proprio
           link ja apontava — a PDP na olhada rapida, o guia no painel de
           produtos — e para onde o clique iria sem JavaScript. */
        fechar();
        window.location.assign(url);
      })
      .then(function () {
        emVoo = null;
      });
  }

  /* SUMMER: o nome do dialogo passa a ser o titulo do produto assim que ele
     existe. aria-labelledby vence o aria-label generico posto na criacao, e
     e removido no fechar() — o titulo sai do DOM junto com o conteudo, e um
     aria-labelledby apontando para id inexistente deixaria o painel sem nome
     nenhum na abertura seguinte. */
  function nomear(conteudo) {
    /* SUMMER: `[data-summer-panel-title]` e o marcador generico; o seletor
       de classe continua atendendo a olhada rapida, que nao o declara. */
    var titulo = conteudo.querySelector('[data-summer-panel-title]') || conteudo.querySelector('.summer-qv__title');
    if (!titulo) return;
    titulo.id = ID_TITULO;
    painel.setAttribute('aria-labelledby', ID_TITULO);
  }

  /* SUMMER: foco preso enquanto o modal esta aberto. Sem isto o Tab saia do
     painel e ia percorrer a colecao atras do veu — um dialogo que deixa o
     foco escapar nao e modal para quem navega por teclado. O carrinho
     lateral (assets/summer-cart.js) e o menu mobile ja prendiam; a olhada
     rapida era a unica das tres que nao prendia, apesar de declarar
     aria-modal="true". offsetParent descarta o que esta escondido: durante
     o carregamento so o botao de fechar existe, e a lista tem que refletir
     isso a cada Tab, nao uma vez na abertura. */
  function focaveis() {
    if (!painel) return [];
    return Array.prototype.filter.call(painel.querySelectorAll(FOCAVEIS), function (el) {
      return el.offsetParent !== null;
    });
  }

  function prenderFoco(evento) {
    var lista = focaveis();
    if (!lista.length) return;

    var primeiro = lista[0];
    var ultimo = lista[lista.length - 1];

    /* Foco no proprio painel (estado da abertura): o Tab tem que entrar na
       lista em vez de pular para a pagina atras. */
    if (document.activeElement === painel) {
      evento.preventDefault();
      (evento.shiftKey ? ultimo : primeiro).focus();
      return;
    }

    if (evento.shiftKey && document.activeElement === primeiro) {
      evento.preventDefault();
      ultimo.focus();
    } else if (!evento.shiftKey && document.activeElement === ultimo) {
      evento.preventDefault();
      primeiro.focus();
    }
  }

  function fechar() {
    if (!modal || modal.hidden) return;
    if (emVoo) emVoo.abort();
    painel.removeAttribute('aria-labelledby');

    modal.classList.remove('is-open', 'is-loading');
    document.documentElement.style.overflow = '';

    /* Espera a saida terminar antes de esconder de verdade, senao o painel
       some de uma vez em vez de deslizar. */
    window.setTimeout(function () {
      if (modal.classList.contains('is-open')) return;
      modal.hidden = true;
      corpo.innerHTML = '';
    }, 250);

    if (gatilhoAtivo) {
      gatilhoAtivo.focus({ preventScroll: true });
      gatilhoAtivo = null;
    }
  }

  document.addEventListener('click', function (evento) {
    var gatilho = evento.target.closest(GATILHO);
    if (!gatilho) return;
    /* Ctrl/Cmd/meio: quem pediu nova aba quer nova aba, com a PDP inteira. */
    if (evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.button !== 0) return;
    evento.preventDefault();
    abrir(gatilho);
  });

  document.addEventListener('keydown', function (evento) {
    if (evento.key === 'Escape') {
      fechar();
      return;
    }
    if (evento.key !== 'Tab' || !modal || modal.hidden) return;
    prenderFoco(evento);
  });

  /* Produto adicionado: o carrinho lateral assume a tela, e dois paineis
     abertos ao mesmo tempo e um a mais. Quem emite este evento e
     assets/carrinho.js. */
  document.addEventListener('summer:cart:changed', fechar);
})();
